var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.778 1.239a.834.834 0 0 0-1.418.596v4.023a.8.8 0 0 0 0 .038v4.401l-3.942-3.86a.834.834 0 1 0-1.167 1.192l4.55 4.457-4.55 4.458a.835.835 0 0 0 1.167 1.192l3.942-3.86v1.086a.8.8 0 0 0 0 .038v7.338a.835.835 0 0 0 1.418.596l5.131-5.032a.834.834 0 0 0 0-1.192l-4.722-4.624 4.722-4.625a.835.835 0 0 0 0-1.192l-5.13-5.03Zm.247 8.67 3.107-3.044-3.104-3.044v2.037a.883.883 0 0 1-.003.073v3.977Zm0 5.018v-.663l3.107 3.043-3.104 3.044V15a.884.884 0 0 0-.003-.073Z"
  })));
};
export default SvgBluetooth;